import { render } from "./TabWrapper.vue?vue&type=template&id=77279c72&scoped=true"
import script from "./TabWrapper.vue?vue&type=script&lang=js"
export * from "./TabWrapper.vue?vue&type=script&lang=js"

import "./TabWrapper.vue?vue&type=style&index=0&id=77279c72&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77279c72"]])

export default __exports__